import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";

const reactPlugin = new ReactPlugin();

const appInsights = new ApplicationInsights({
    config: {
        connectionString: process.env.REACT_APP_AI_CONNECTION_STRING,
        extensions: [reactPlugin],
        enableAutoRouteTracking: true,
        enableCorsCorrelation: true,
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true,
        disableFetchTracking: false,
        enableUnhandledPromiseRejectionTracking: true,
    },
});

if (process.env.REACT_APP_AI_CONNECTION_STRING) {
    appInsights.loadAppInsights();
}

export { reactPlugin, appInsights };